module.exports = __webpack_public_path__ + "img/EmergencyOutlined.025c7822.svg";